import React from "react";
import PaginaPublica from "../PaginasPublicas/PaginaPublica";
import { imagenesCampeonatoSC } from "./imagenesCampeonatoSC";

function Revista() {
  return <PaginaPublica titulo="Campeonato Santa Cruz" imagenes={imagenesCampeonatoSC} />;
}

export default Revista;